const PartialListing = ({ isPartialListingManaged = false, partialFeedPropertyId = '', partialFeedName = '' }) => ({
  isPartialListingManaged: Boolean(isPartialListingManaged),
  partialFeedPropertyId: String(partialFeedPropertyId),
  partialFeedName: String(partialFeedName),
});

export default PartialListing;

export type PartialFeedProps = ReturnType<typeof PartialListing>;
